import React from "react";

const _AddToCalIcon = ({ className = "" }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.94851 14.2718H2.06646C1.74276 14.2718 1.43232 14.1432 1.20343 13.9143C0.974537 13.6854 0.845947 13.375 0.845947 13.0513V3.28716C0.845947 2.96346 0.974537 2.65302 1.20343 2.42413C1.43232 2.19524 1.74276 2.06665 2.06646 2.06665H13.0511C13.3748 2.06665 13.6852 2.19524 13.9141 2.42413C14.143 2.65302 14.2716 2.96346 14.2716 3.28716V6.9487"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.845947 5.72827H14.2716"
            stroke="currentColor"
            strokeLinejoin="round"
        />
        <path
            d="M4.50757 3.28722V0.846191"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.6101 3.28722V0.846191"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.38953 14.2719C9.38953 15.5667 9.90388 16.8085 10.8194 17.7241C11.735 18.6396 12.9768 19.154 14.2716 19.154C15.5664 19.154 16.8081 18.6396 17.7237 17.7241C18.6393 16.8085 19.1536 15.5667 19.1536 14.2719C19.1536 12.9771 18.6393 11.7354 17.7237 10.8198C16.8081 9.90425 15.5664 9.38989 14.2716 9.38989C12.9768 9.38989 11.735 9.90425 10.8194 10.8198C9.90388 11.7354 9.38953 12.9771 9.38953 14.2719Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.2719 11.8311V16.7131"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.8308 14.2717H16.7129"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AddToCalIcon = React.memo(_AddToCalIcon);